// This is a mixin which provides an object with the ability to set and get any kind of configuration key/value pairs from the components dataset attribute.

import {resolvePath} from "../helpers/object";

export function MixinDatasetConfigurable(obj) {
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

        // Set our `datasetConfig` value from anything that is in the elements data attribute with the the key 'configDatasetKey'.
        setDatasetConfig(configDatasetKey) {
            this.datasetConfig = this.getDatasetConfig(configDatasetKey);
        },

        // Pass in a `configDatasetKey` that is a key for the element's dataset where we'll find a JSON string with configuration key/value pairs.
        getDatasetConfig(configDatasetKey) {
            if (typeof this.element === 'undefined' || this.element === null) { return }
            if(!this.element.dataset) return;
            let rawData = this.element.dataset[configDatasetKey];
            let data = {};
            if (rawData) {
                try {
                    data = JSON.parse(rawData);
                } catch(e) {
                    try {
                        data = JSON.parse(decodeURI(rawData));
                    } catch(e) {
                        console.error('JSON Parse Error while reading data attribute JSON.', e);
                    }
                }
            }
            return data;
        },

        // Pass in a 'configKey' that is a key within the datasetConfig object.
        // The 'configKey' can be a path string to nested objects, eg. `key1.key2`.
        getDatasetConfigValue(path) {
            if (!this.hasDatasetConfig) return;
            return resolvePath(this.datasetConfig, path);
        },

        hasDatasetConfig() {
            return !(typeof this.datasetConfig === 'undefined' || this.datasetConfig === null)
        }

    });
}
